import { fabric } from 'fabric'

export default {
  data() {
    return {
      pagesCanvas: null, // 存储页面热区
      curLinkIndex: -1,
      hotZone: [
        //TODO 假数据
        {
          link: 1,
          position: [
            { x: 50, y: 10 },
            { x: 100, y: 10 },
            { x: 200, y: 10 },
            { x: 200, y: 100 },
            { x: 50, y: 100 },
            { x: 10, y: 100 }
          ]
        },
        {
          link: 2,
          position: [
            { x: 10, y: 110 },
            { x: 100, y: 110 },
            { x: 200, y: 110 },
            { x: 200, y: 300 },
            { x: 50, y: 300 },
            { x: 10, y: 300 }
          ]
        }
      ]
    }
  },
  watch: {
    totalPage(newVal) {
      this.pagesCanvas = new Array(newVal)
    }
  },
  methods: {
    canvasTap() {
      // 避免非点击动作，如滑动翻页触发链接跳转
      // console暂留
      console.log('curLinkIndex', this.curLinkIndex)
    },
    initCanvas(index) {
      // TODO, canvas应覆盖全页
      let canvas = new fabric.Canvas(`canvas${index}`, {
        width: 300,
        height: 400,
        selection: false, // 不可成组
        hoverCursor: 'pointer'
      })

      // hover热区效果，PC端有hover效果，移动端仅有点击变色
      if (!this.isMobile) {
        canvas.on('mouse:over', function(e) {
          if (e.target) {
            e.target.set('fill', 'rgba(250, 177, 94, 0.3)')
            canvas.renderAll()
          }
        })
        canvas.on('mouse:out', function(e) {
          if (e.target) {
            e.target.set('fill', 'transparent')
            canvas.renderAll()
          }
        })
      }
      // TODO 点击
      // 点击与翻页效果冲突问题
      return canvas
    },
    addHotZone(canvas) {
      // TODO 动态绘制 this.hotZone 仍为假数据
      for (let i = 0; i < this.hotZone.length; i++) {
        const poly = this.draw(this.hotZone[i].position, i)
        canvas.add(poly)
      }
    },
    draw(position, index) {
      const poly = new fabric.Polyline(position, {
        fill: 'transparent',
        lockMovementX: true, // 不可横向移动
        lockMovementY: true, // 不可纵向移动
        hasControls: false, // 隐藏操作框
        hasBorders: false, // 隐藏选中框线
        stroke: 'red', //TODO 去掉
        link: index // 存储当前选中的文章链接索引
      })

      // TOFIX 移动端如果没有再点击canvas， 无法触发deselected
      // 方案问题，如果每次翻页都重新绘制，会有点击状态翻走，回来无法再点击的问题
      // 考虑翻走时，重置所有高亮样式
      poly.on('selected', (e) => {
        this.curLinkIndex = e.target.link
        // 移动端选中后高亮
        if (this.isMobile) {
          e.target.set('fill', 'rgba(250, 177, 94, 0.3)')
        }
      })
      poly.on('deselected', (e) => {
        // 移动端取消选中恢复
        if (this.isMobile) {
          e.target.set('fill', 'transparent')
        }
      })
      return poly
    },
    digitalPaperInit(pageIndex) {
      // 仅在当前页没有canvas时进行初始化
      const canvas = this.pagesCanvas[pageIndex]
      if (canvas) {
        return
      }
      let curCanvas = this.initCanvas(pageIndex) // 创建单页画布
      this.addHotZone(curCanvas) // 添加页面热区
      this.pagesCanvas[pageIndex] = curCanvas
    }
  }
}
